import * as React from "react";
import type { SVGProps } from "react";
const SvgPlanNotification = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={17}
    fill="none"
    viewBox="0 0 17 17" {...props}
  >
    <path
      fill="#9811D1"
      fillRule="evenodd"
      d="M4.389 2.062h8.694c.623 0 1.132.523 1.132 1.163v11.342a.55.55 0 0 1-.539.553h-8.26a.55.55 0 0 1-.538-.553V3.225c0-.416-.216-.783-.538-.988a.095.095 0 0 1-.04-.107.09.09 0 0 1 .089-.068M2.021 3.474c0-.76.607-1.145 1.195-1.147.553-.002 1.089.335 1.089 1.017V8.85c0 .13-.103.236-.23.236h-.976c-.593 0-1.078-.498-1.078-1.107z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPlanNotification;
